import React, { useContext, useEffect } from 'react'
import PrimaryButton from '@/product//components/atoms/PrimaryButton'
import UserContext from '@/product//context/user/userContext'
import { mapData } from '@/product//common/components'
import { useFormik } from 'formik'
import '../Dashboard.css'
import { Button, Link } from '@material-ui/core'
import AuthContext from '@/product/context/auth/authContext'

const ChangePasswordForm = (props) => {
    const userContext = useContext(UserContext)
    const authContext = useContext(AuthContext)

    const { user } = authContext

    const {
        updateProfile,
        responseStatus: responseStatusUser,
        forgotPassword,
        clearResponse,
    } = userContext

    const formikChange = useFormik({
        initialValues: props.initialValues,
        validationSchema: props.validationPassword,
        onSubmit: (values) => {
            updateProfile(values)
        },
    })
    const formData = {
        formik: formikChange,
        data: props.data,
    }
    useEffect(() => {
        if (responseStatusUser) {
            if (
                responseStatusUser.from === 'updateProfile' ||
                responseStatusUser.from === 'updatePreference'
            ) {
                if (responseStatusUser.status === 'success') {
                    formikChange.resetForm()
                }
            }
        }
    }, [responseStatusUser])

    const handleForgotPassword = () => {
        if (user?.email) {
            forgotPassword({ email: user?.email })
        }
    }

    return (
        <form onSubmit={formikChange.handleSubmit} autoComplete="nofill">
            <div className="row changePassRow">{Object.values(mapData(formData))}</div>
            <Button onClick={handleForgotPassword} className="forgotP">
                Forgot password?
            </Button>
            <PrimaryButton
                id="change_password_change"
                type="submit"
                btnSize="small"
                label="Update Password"
            />
        </form>
    )
}

export default ChangePasswordForm
